import { render, staticRenderFns } from "./InterventionPlanGoals.vue?vue&type=template&id=6e004b51&scoped=true"
import script from "./InterventionPlanGoals.vue?vue&type=script&lang=js"
export * from "./InterventionPlanGoals.vue?vue&type=script&lang=js"
import style0 from "./InterventionPlanGoals.vue?vue&type=style&index=0&id=6e004b51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e004b51",
  null
  
)

export default component.exports